import reframe from 'nike-re-framejs';
import Immutable from 'immutable';

reframe.regSub('app_download.texts', db => db.getIn(['app_download'], Immutable.Map()));
